import React, { useMemo } from 'react';
import {
  Alert, Button, Card, Col, Container, Row, Spinner,
} from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { readPersistedCampaignCode } from '../../campaignSession';
import { EXTERNAL_SALES_BASE_PATH } from '../../config';
import { PurchaseSummary } from './PurchaseSummary';
import { useClaimStatus } from './useClaimStatus';
import { useNoReferrerPolicy } from './useNoReferrerPolicy';

export function SuccessPage() {
  const { search } = useLocation();
  const history = useHistory();
  const { token, purchaseId } = useMemo(() => {
    const params = new URLSearchParams(search);
    return { token: params.get('token') ?? '', purchaseId: params.get('purchaseId') ?? undefined };
  }, [search]);

  useNoReferrerPolicy();
  const state = useClaimStatus(token, purchaseId);
  const campaignCode = readPersistedCampaignCode();

  const handleBackToStore = () => {
    if (campaignCode) {
      history.push(`${EXTERNAL_SALES_BASE_PATH}/c/${encodeURIComponent(campaignCode)}`);
    } else {
      history.goBack();
    }
  };

  return (
    <div className="external-sales-page">
      <Container as="main" className="external-sales-success min-vh-100 d-flex align-items-center py-5">
        <Row className="justify-content-center w-100">
          <Col xs={12} md={7} lg={5}>
            <Card className="shadow-sm border-0">
              <Card.Body className="p-4 text-center">
                {state.kind === 'finalizing' && (
                  <div role="status">
                    <Spinner animation="border" variant="primary" aria-hidden="true" />
                    <p className="mt-3 mb-0 text-muted">Finalizing your purchase…</p>
                  </div>
                )}
                {state.kind === 'paid' && <PurchaseSummary item={state.item} orderNumber={state.orderNumber} />}
                {state.kind === 'unpaid' && (
                  <Alert variant="warning" className="mb-0">Your payment didn’t complete. Please try again.</Alert>
                )}
                {state.kind === 'unresolved' && (
                  <Alert variant="warning" className="mb-0 text-start">
                    <p className="mb-2">
                      Something went wrong confirming your purchase, and your confirmation email
                      hasn&rsquo;t arrived yet.
                    </p>
                    {state.operationId && (
                      <p className="mb-2">
                        Please contact support with your order reference:
                        {' '}
                        <strong>{state.operationId}</strong>
                      </p>
                    )}
                    <p className="mb-0">
                      Need help?
                      {' '}
                      <a href="https://form.typeform.com/to/ohAZCEm4" target="_blank" rel="noreferrer">Contact support</a>
                    </p>
                  </Alert>
                )}
                {state.kind !== 'finalizing' && (
                  <Button
                    variant="primary"
                    size="lg"
                    block
                    className="mt-4"
                    onClick={handleBackToStore}
                  >
                    Back to store
                  </Button>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
